module.exports = new __parcel__URL__("crash_3.8ba5b29e.mp3").toString();